import React from 'react';
import classes from "../AboutUs/AboutUs.module.css";
import floor from "../Carousel/floor.jpg"



function AboutUs(){
    return(
        <div className={classes.box}>
            {/* <div className={classes.gridItem}>
                <h2>About us</h2>
                <h5 >But I must explain to you how all 
                    this mistaken idea of denouncing pleasure and praising pain was born and
                     I will give you a complete account of the system, and expound the actual  
                     teachings of the great explorer of the truth, the master-builder of human happiness.
                      No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because 
                      those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. </h5>
            
            </div> */}
            <div className={classes.gridItemImg}>
            <h2>About us</h2>
            <h5 >We sell Designer and Niche fragrances in decant spray bottles in a fraction
                 of the full bottle price. So if you want to build up a designer fragrance collection, 
                 this is the right place to start. All of our fragrances are 100% authentic. We add new
                  fragrances after intensive research, so that you can blind buy without any hesitation. All 
                  the details of the fragrances are given in the description so that you can get a brief 
                  idea about what the fragrance will smell like. Contact us anytime for any kind of queries
                   and fragrance tips. We are 24/7 here to serve you.</h5>
                
                {/* <img className={classes.gridItemImg}  alt="loading..."/> */}
            </div>
            

        </div>
      



    )
}

export default AboutUs;

